import template from './apiaccesslog-detail.html';
import controller from './apiaccesslog-detail.controller';

let apiaccesslogDetailComponent = {
  bindings: {},
  template,
  controller
};

export default apiaccesslogDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/apiaccesslog/apiaccesslog-detail.component.js